import React from 'react';
import { motion } from 'framer-motion';
import styles from './Question.module.css';

function Question({ title, questionImgUrl, isLong, questionFontSize }) {
  return (
    <motion.div
      className={styles.block}
      initial={{ x: 1000, opacity: 0, translateY: isLong ? '-70%' : '-60%' }}
      animate={{ x: 0, opacity: 1, translateY: isLong ? '-70%' : '-60%' }}
      transition={{ duration: 1 }}
      key={title}>
      <div className={styles[questionImgUrl ? 'question' : 'question-noImg']}>
        <motion.div
          initial={{ x: 1000, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 2, delay: 0.5 }}
          className={styles.title}>
          <p
            style={{
              fontSize: isLong
                ? `${0.8 * questionFontSize}rem`
                : `${questionFontSize}rem`,
            }}>
            {title}
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
}

export default Question;
